import { memo } from 'react';

interface Props {
  x: number;
  y: number;
  text: string;
}

/** Semi-transparent ghost rectangle shown while dragging a node. */
export const DragGhost = memo(function DragGhost({ x, y, text }: Props) {
  const padding = 12;
  const estimatedWidth = Math.max(60, text.length * 8 + padding * 2);
  const height = 32;

  return (
    <g
      transform={`translate(${x - estimatedWidth / 2}, ${y - height / 2})`}
      style={{ pointerEvents: 'none' }}
      opacity={0.6}
    >
      <rect
        width={estimatedWidth}
        height={height}
        rx={6}
        ry={6}
        fill="#4a90d9"
        stroke="#2a6cb6"
        strokeWidth={1}
      />
      <text
        x={estimatedWidth / 2}
        y={height / 2}
        textAnchor="middle"
        dominantBaseline="central"
        fill="#ffffff"
        fontSize={13}
        fontFamily="system-ui, -apple-system, sans-serif"
        style={{ userSelect: 'none' }}
      >
        {text || ' '}
      </text>
    </g>
  );
});
